var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{staticClass:"iti-form__button iti-form__button--space-right",class:{'iti-form__button--red': _vm.isSuggested, 'iti-form__button--disabled': _vm.isDisabled},attrs:{"type":"button","value":_vm.label}})}
var staticRenderFns = []

export { render, staticRenderFns }